import axios from "axios";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL_PROD || process.env.REACT_APP_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL_PROD;

const api = axios.create({
  baseURL
});

let authExpiryHandled = false;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("uneptoken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = String(error.response?.data?.error || "").toLowerCase();
    const requestUrl = String(error.config?.url || "");
    const isLoginRequest = requestUrl.includes("/users/login");
    const hasToken = Boolean(localStorage.getItem("uneptoken"));
    const isAuthExpiry =
      status === 401 &&
      hasToken &&
      !isLoginRequest &&
      (message.includes("expired token") ||
        message.includes("invalid or expired token") ||
        message.includes("invalid token") ||
        message.includes("authorization header is required"));

    if (isAuthExpiry && !authExpiryHandled) {
      authExpiryHandled = true;
      window.dispatchEvent(new CustomEvent("auth:expired"));

      window.setTimeout(() => {
        authExpiryHandled = false;
      }, 500);
    }

    return Promise.reject(error);
  }
);

export default api;
